"use client";
export const redirectShab = async () => {
  const isAppRouter =
    Boolean(process.env.NEXT_PUBLIC_APP_NAME_TICKET) ||
    process.env.NEXT_PUBLIC_APP_NAME === "homepage";
  const redirectShabModule = await (isAppRouter
    ? import("./open-modal-v2")
    : import("./open-modal"));

  redirectShabModule.useShabRedirect();
};
